<template>
    <div>
        <v-btn @click="dialog = true" color="primary">
            <v-icon left>mdi-file-plus</v-icon>
            Add Questions & Answers
        </v-btn>

        <v-dialog v-model="dialog" max-width="700">
            <v-card>
                <v-card-title>{{edit ? 'Update' : 'Add'}} Questions & Answers</v-card-title>
                <v-card-text>
                    <p class="text-subtitle-2">
                        Provide Questions & Answers allow agent to automatically answer customers questions with accurate and relevant information
                    </p>
                    <div v-if="edit && data.question" class="box">
                        <v-text-field
                            v-model="updateForm.question"
                            label="Question"
                            placeholder="Enter question here"
                        ></v-text-field>

                        <v-textarea
                            v-model="updateForm.answer"
                            label="Answer"
                            placeholder="Enter answer here"
                        ></v-textarea>
                    </div>
                    <template v-else> 
                        <div v-for="(item, index) in addForm" :key="index" class="box">
                            <v-text-field
                                v-model="item.question"
                                label="Question"
                                placeholder="Enter question here"
                            ></v-text-field>

                            <v-textarea
                                v-model="item.answer"
                                label="Answer"
                                placeholder="Enter answer here"
                            ></v-textarea>
                            <div class="text-end">
                                <v-btn @click="addForm.splice(index, 1)" small fab color="error">
                                    <v-icon left>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <v-btn @click="addForm.push({ question: '', answer: '' })" color="primary">
                            <v-icon left>mdi-plus</v-icon>
                            Add more
                        </v-btn>
                    </template>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        :loading="loading"
                        :disabled="loading"
                        color="primary"
                        @click="save"
                    >
                        Save changes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'QAForm',
    props: {
        botId: {
            type: String,
            required: true
        },
        edit: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {
                return {
                    uuid: '',
                    question: '',
                    answer: ''
                }
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            addForm: [{
                question: '',
                answer: ''
            }],
            updateForm: {
                question: '',
                answer: ''
            },
        }
    },
    mounted() {
        if (this.edit) {
            this.updateForm = {
                question: this.data.question,
                answer: this.data.answer
            }
            this.dialog = true
        }
    },
    watch: {
        edit(val) {
            this.dialog = val
            if (val) {
                this.updateForm = {
                    question: this.data.question,
                    answer: this.data.answer
                }
            }
        },
        dialog(val) {
            this.$emit('close', val)
            if (!val) {
                this.addForm = [{
                    question: '',
                    answer: ''
                }]
                this.updateForm = {
                    question: '',
                    answer: ''
                }
            }
        }
    },
    methods: {
        showError(message) {
            this.$store.dispatch("setSnackbar", {
                text:  message,
                color: "error",
                status: true,
            });
        },
        showSuccess(message) {
            this.$store.dispatch("setSnackbar", {
                text: message,
                color: "success",
                status: true,
            });
        },
        async save() {
            try {
                this.loading = true
                if(this.edit && this.data.question) {
                    await this.$store.dispatch('llm/qa/update', {
                        botID: this.botId,
                        id: this.data.uuid,
                        data: this.updateForm
                    })
                }else{
                    await this.$store.dispatch('llm/qa/add', {
                        botID: this.botId,
                        data: this.addForm
                    })
                }

                this.dialog = false
                this.showSuccess(`Questions & Answers has been ${this.edit ? 'updated' : 'created'} successfully`)
                this.$emit('submitted')
            } catch (error) {
                console.error(error)
                this.showError('An error occurred while creating Questions & Answers')
            } finally {
                this.loading = false
            }
        },

    }
}
</script>
<style lang="scss"  scoped>
.box {
    margin-bottom: 20px;
    border: 2px dashed #ccc;
    padding: 10px;
    border-radius: 8px;
}
</style>